import { imageUrl } from 'app/frontend/base/helpers'
import {
  RaidMarkerType,
  raidMarkerTypes,
} from 'app/frontend/types/custom/RaidMarker'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Textarea } from '@/components/ui/textarea'
import { Button } from '@/components/ui/button'

type CastNotePopoverProps = {
  open: boolean
  position: { x: number; y: number }
  draft: string
  textareaRef: React.RefObject<HTMLTextAreaElement>
  onDraftChange: (next: string) => void
  onOpenChange: (open: boolean) => void
  onInsertMarker: (marker: RaidMarkerType) => void
}

const CastNotePopover = ({
  open,
  position,
  draft,
  textareaRef,
  onDraftChange,
  onOpenChange,
  onInsertMarker,
}: CastNotePopoverProps) => {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button
          type='button'
          className='absolute h-0 w-0 opacity-0 pointer-events-none'
          style={{
            left: position.x,
            top: position.y,
          }}
        />
      </PopoverTrigger>
      <PopoverContent align='start' className='p-3 space-y-3'>
        <p className='text-xs text-muted-foreground'>
          <em>
            Messages will appear in Northern Sky Raid Tools with text-to-speech
          </em>
        </p>

        <Textarea
          ref={textareaRef}
          rows={5}
          value={draft}
          onChange={(event) => onDraftChange(event.target.value)}
        />
        <div className='flex items-center gap-1.5'>
          {raidMarkerTypes.map((marker) => (
            <Button
              key={marker}
              type='button'
              size='sm'
              variant='outline'
              onClick={() => onInsertMarker(marker)}
            >
              <img
                src={imageUrl(`markers/${marker}.webp`)}
                className='h-4 w-4'
              />
            </Button>
          ))}
          <Button
            type='button'
            variant='outline'
            size='sm'
            className='ml-1'
            onClick={() => onOpenChange(false)}
          >
            Close
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default CastNotePopover
